import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/block/hero/yellow-bus.webp")